import {
  Container,
  Button,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  MenuItem,
  Box,
  Menu,
  Avatar,
  Grid,
  Stack,
  Drawer,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import {useState, useEffect} from 'react';
import axios from '../../axios';
import {Link, useNavigate} from 'react-router-dom';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BusinessIcon from '@mui/icons-material/Business';
import axiosRetry from 'axios-retry';
import {useKeycloak} from '@react-keycloak/web';
import keycloak from '../../Keycloak';
import * as React from 'react';
import SearchBar from '../search/SearchBar';
import MenuNotConnected from './MenuNotConnected';
import MenuConnected from './MenuConnected';
import MenuItems from './MenuItems';
import {useAuthentication} from '../auth/hooks/useAuthentication';
import {withAuthContext} from '../auth/context/authContext';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import NotificationBell from '../notification/NotificationBell';
import AvatarProfile from '../dashboard/AvatarProfile';
import MenuItemsMobile from './MenuItemsMobile';
import {useRole} from '../userInfo/hooks/useRole';
import {useUserInfo} from '../userInfo/hooks/useUserInfo';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LogoutIcon from '@mui/icons-material/Logout';
import ReorderIcon from '@mui/icons-material/Reorder';
import CircularProgress from '@mui/material/CircularProgress';

function HeaderConnected({
  token,
  logo,
  setToken,
  setSearchResponse,
  setSearchInput,
}) {
  const {profil} = useUserInfo();
  const [menus, setMenus] = useState([]);
  const {canPublish} = useRole();

  const navigate = useNavigate();

  const {keycloakLogout, keycloakLogin, isAuthenticated, isLoading} =
    useAuthentication();

  const {mode} = useDarkMode();

  useEffect(() => {
    document.onscroll = () => {
      const top =
        document.documentElement.scrollTop - document.documentElement.clientTop;
      if (top === 0) {
        document.getElementById('app-bar') &&
          document.getElementById('app-bar').classList.add('app-bar-static');
      } else {
        document.getElementById('app-bar') &&
          document.getElementById('app-bar').classList.remove('app-bar-static');
      }
    };
  }, []);

  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);

  const handleOpenNavMenu = event => {
    setAnchorElNav(event.currentTarget);
  };
  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleOpenUserMenu = event => {
    setAnchorElUser(event.currentTarget);
  };
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const logout = () => {
    localStorage.clear();
    navigate('/login');
  };

  return (
    <AppBar
      className={'app-bar-static'}
      id={'app-bar'}
      sx={{
        backgroundColor: mode.settings.cardBackgroundColor,
        py: 1,
        px: 2,
      }}>
      <Toolbar disableGutters>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            width: '130px',
            textDecoration: 'none',
            textAlign: 'center',
            cursor: 'pointer',
          }}
          onClick={() => navigate('/')}>
          <img alt={'Logo OHS'} src={mode.settings.logoUrl} role="img" />
        </Box>
        <Drawer
          open={Boolean(anchorElNav)}
          onClose={handleCloseNavMenu}
          anchor="right"
          sx={{position: 'relative'}}>
          <Button
            className="btnPink"
            onClick={handleCloseNavMenu}
            size={'large'}
            role="presentation"
            startIcon={<ArrowBackIcon />}
            sx={{borderRadius: 'unset'}}>
            Fermer
          </Button>
          <Stack
            sx={{width: 350, p: 2, mt: 4, flexGrow: 1}}
            onClick={handleCloseNavMenu}>
            <MobileMenu
              isAuthenticated={isAuthenticated}
              keycloakLogin={keycloakLogin}
              keycloakLogout={keycloakLogout}
            />
          </Stack>
        </Drawer>

        <Box
          sx={{
            display: {xs: 'none', md: 'none', lg: 'flex'},
            justifyContent: 'center',
            marginLeft: 1,
          }}>
          <MenuConnected />
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            justifyContent: 'flex-end',
          }}>
          <Stack
            direction={'row'}
            alignItems={'center'}
            gap={'10px'}
            justifyItems="center"
            flexGrow={1}>
            <Box flexGrow={1}>
              <SearchBar
                setSearchResponse={setSearchResponse}
                setSearchInput={setSearchInput}
              />
            </Box>
            <Stack
              direction="row"
              sx={{display: {xs: 'none', md: 'none', lg: 'flex'}}}>
              <Stack alignItems="center" direction="row">
                <MenuItem
                  role="presentation"
                  sx={{
                    minWidth: '100px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '10px',
                    height: '100%',
                  }}
                  justifyContent="center"
                  disabled={
                    !(profil && profil.subscriptionStatus === 'active')
                  }>
                  <Link
                    to={`${process.env.REACT_APP_NEXTCLOUD_BASE_URL}${process.env.REACT_APP_NEXTCLOUD_MESSAGE_URL}`}
                    aria-label={'Aller à'}
                    style={{textDecoration: 'none'}}>
                    <Stack
                      direction={'column'}
                      alignItems={'center'}
                      justifyContent="center">
                      <img
                        src={`/assets/icon/chat.png`}
                        alt={'Messages'}
                        style={{width: 34, height: 34}}
                      />
                      <Typography
                        variant={'subtitle5'}
                        className={'menu_item_label'}
                        style={{color: mode.settings.textColor}}>
                        Messages
                      </Typography>
                    </Stack>
                  </Link>
                </MenuItem>
                <NotificationBell />
              </Stack>

              <Button
                disableElevation
                onClick={handleOpenUserMenu}
                style={{
                  backgroundColor: mode.settings.inputBackgroundColor,
                }}
                className={'text-grey-dark'}>
                <AvatarProfile size={40} showName={false} />
              </Button>
              <Menu
                anchorEl={anchorElUser}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}>
                <MenuItem disableRipple onClick={() => navigate('/profile')}>
                  <Stack flexDirection={'row'} alignItems={'center'}>
                    <AccountCircleIcon />
                    <Box>Mon compte</Box>
                  </Stack>
                </MenuItem>
                {canPublish && (
                  <MenuItem
                    disableRipple
                    onClick={() =>
                      window.location.replace(
                        `${process.env.REACT_APP_BACK_OFFICE_URL}`,
                      )
                    }>
                    <Stack flexDirection={'row'} alignItems={'center'}>
                      <BusinessIcon />
                      <Box>Back Office</Box>
                    </Stack>
                  </MenuItem>
                )}
                <MenuItem disableRipple onClick={() => keycloakLogout()}>
                  <Stack flexDirection={'row'} alignItems={'center'}>
                    <LogoutIcon />
                    <Box>Déconnexion</Box>
                  </Stack>
                </MenuItem>
              </Menu>
            </Stack>
          </Stack>
        </Box>

        <Box
          sx={{
            display: {xs: 'flex', md: 'flex', lg: 'none'},
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}>
          <IconButton
            size="large"
            aria-label="Compte de l'utilisateur"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleOpenNavMenu}
            sx={{color: mode.settings.textColor5}}
            role={'img'}>
            <MenuIcon role={'img'} aria-label={'menu mobile'} />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

const MobileMenu = ({isAuthenticated, keycloakLogin, keycloakLogout}) => {
  const navigate = useNavigate();
  const {mode} = useDarkMode();

  return (
    <>
      {isAuthenticated ? (
        <>
          <Stack direction={'column'} gap={4} flexGrow={1}>
            <Box onClick={() => navigate('/')}>
              <MenuItemsMobile
                label={'Accueil'}
                link={''}
                imageSrc={`/assets/icon/home.png`}
              />
            </Box>
            <Box onClick={() => navigate('/communities')}>
              <MenuItemsMobile
                label={'Communautés'}
                link={''}
                imageSrc={`/assets/icon/communauté.png`}
              />
            </Box>
            <Box onClick={() => navigate('/product-search')}>
              <MenuItemsMobile
                label={'Produits et service'}
                link={''}
                imageSrc={`/assets/icon/produit_service.png`}
              />
            </Box>
            <Box onClick={() => navigate('/favorite')}>
              <MenuItemsMobile
                label={'Favoris'}
                link={''}
                imageSrc={`/assets/icon/Etoile.png`}
              />
            </Box>
            <Box onClick={() => navigate('/notifications')}>
              <MenuItemsMobile
                label={'Notifications'}
                link={''}
                imageSrc={'/assets/icon/bell.png'}
              />
            </Box>
          </Stack>
          <Stack direction="row" justifyContent="center" gap={2}>
            <Button
              className="btnPink"
              onClick={() => navigate('/profile')}
              size={'large'}
              role="presentation"
              startIcon={<AccountCircleIcon />}>
              <Typography variant={'subtitle1'} sx={{marginTop: 0.5}}>
                Profile
              </Typography>
            </Button>
            <Button
              className="btnPink"
              onClick={() => keycloakLogout()}
              size={'large'}
              role="presentation"
              startIcon={<LogoutIcon />}>
              <Typography variant={'subtitle1'} sx={{marginTop: 0.5}}>
                Déconnexion
              </Typography>
            </Button>
          </Stack>
        </>
      ) : (
        <>
          <Stack direction={'column'} gap={4} flexGrow={1}>
            <MenuItemsMobile
              label={'Accueil'}
              link={''}
              imageSrc={'/assets/icon/home.png'}
            />
            <MenuItemsMobile
              label={'Présentation'}
              link={'#service'}
              imageSrc={'/assets/icon/présentation.png'}
            />
            <MenuItemsMobile
              label={'Fonctionnalités'}
              link={'#text_fonctionality'}
              imageSrc={'/assets/icon/Fonctionnalité.png'}
            />
            <MenuItemsMobile
              label={'Abonnement'}
              link={'#subscription'}
              imageSrc={'/assets/icon/Abonnement_(2).png'}
            />
            <MenuItemsMobile
              label={'Qui sommes-nous'}
              link={'#who'}
              imageSrc={'/assets/icon/qui_sommes_nous.png'}
            />
            <MenuItemsMobile
              imageSrc={`/assets/icon/domain.png`}
              label={'Nos établissements'}
              link={'institutions'}
            />
          </Stack>
          <Stack direction="row" justifyContent="center" gap={2}>
            <Button
              role="presentation"
              className="btnPink"
              sx={{mr: 1}}
              size={'large'}
              startIcon={
                <img
                  src={`/assets/icon/s_inscrire.png`}
                  alt={''}
                  style={{width: 20, height: 20}}
                />
              }
              onClick={() => navigate('registration')}>
              <Typography variant={'subtitle1'} sx={{marginTop: '4px'}}>
                S'inscrire
              </Typography>
            </Button>
            <Button
              className="btnPink"
              onClick={() => keycloakLogin()}
              size={'large'}
              role="presentation"
              startIcon={
                <img
                  src={`/assets/icon/se_connecter.png`}
                  alt={''}
                  style={{width: 20, height: 20}}
                />
              }>
              <Typography variant={'subtitle1'} sx={{marginTop: 0.5}}>
                Se connecter
              </Typography>
            </Button>
          </Stack>
        </>
      )}
    </>
  );
};

export default withAuthContext(HeaderConnected);
